import { useEffect, useState } from "react";
import Apiservice from "../Apiservice";

const Dashboard = () => {
    const [rolesUsers, setRoledUsers] = useState([]);
    const [exams, setExams] = useState([]);
    const [passedClick, setPassedClick] = useState(false);
    const [clickedExamId, setClickedExamId] = useState(null);
    const [retrievedUsers, setRetrievedUsers] = useState([]);
    const [selectedExam, setSelectedExam] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [clickedRole, setClickeRole] = useState(false);
    const [selectedRole, setSelectedRole] = useState("");
    const [retrievedRoleUsers, setRetrievedRoleUsers] = useState([]);
    const [noOfUsers, setNoOfUsers] = useState(0);
    const [activeRole, setActiveRole] = useState("");  // Track active role
    const [activeExam, setActiveExam] = useState(null); // Track active exam

    const [selectedRoleCardIndex, setSelectedRoleCardIndex] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);
    const [loading, setLoading] = useState(true);
    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        // Add event listener for window resize
        window.addEventListener("resize", handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty dependency array to run effect only once


    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = { status: 0 };
                const token = localStorage.getItem("access_token");

                const headers = {
                    access_token: token,
                };
                const result = await Apiservice.DashBoard(data, headers);
                if (result.success) {
                    const retrievedData = result.data[0];
                    setExams(retrievedData.exam || []);
                    setRoledUsers(retrievedData.users || []);
                    setNoOfUsers(retrievedData.noOfUsers);
                    localStorage.setItem('initialDateForAttendance', retrievedData.initialDateForData)
                    setLoading(false)
                }
            } catch (error) {
                console.error("Error fetching dashboard data:", error);
            }
        };
        fetchData();
    }, []);
    console.log("passed Click", passedClick)
    // const handleViewClick = (data, type, examId) => {
    //     if((clickedExamId===examId)&&(selectedType===(type === 'passedUsers' ? "Passed Users" :
    //         type === 'processedUsers' ? "Processed Users" :
    //             type === 'nonAttendedUsers' : "Non Attended Users")){
    //         setPassedClick(!passedClick);
    //     }else{
    //         setPassedClick(passedClick)
    //     }

    //     setRetrievedUsers(data[type] || []);
    //     setClickedExamId(examId);
    //     setSelectedExam(data.examName);
    //     setSelectedType(type === 'passedUsers' ? "Passed Users" :
    //         type === 'processedUsers' ? "Processed Users" :
    //             type === 'nonAttendedUsers' ? "Non Attended Users" : "Internal Error");
    //     setActiveExam(examId);  // Set the active exam

    //     console.log("passedClick", passedClick, "type", type, "examId", examId)
    // };
    const [selectedExamIndex, setSelectedExamIndex] = useState(null);
    const [selectedTypeIndex, setSelectedTypeIndex] = useState(null);
    const handleViewClick = (data, type, examId, examIndex) => {
        const newType =
            type === 'passedUsers' ? "Passed Users" :
                type === 'processedUsers' ? "Processed Users" :
                    type === 'nonAttendedUsers' ? "Non Attended Users" : "Internal Error";

        if (clickedExamId === examId && selectedType === newType) {
            // Toggle `passedClick` for the same examId and type
            setPassedClick((prev) => !prev);
        } else {
            // Show data directly without toggling `passedClick` for different examId or type
            setPassedClick(true);
        }

        // Update states
        setRetrievedUsers(data[type] || []);
        setClickedExamId(examId);
        setSelectedExam(data.examName);
        setSelectedType(newType);
        setActiveExam(examId);

        setSelectedExamIndex(examIndex);
        setSelectedTypeIndex(type)

        console.log("passedClick:", passedClick, "type:", type, "examId:", examId);
    };



    const handleRoleUserView = async (data, role, index) => {
        if (selectedRole === role) {
            setClickeRole(!clickedRole);
        } else {
            setClickeRole(clickedRole);
        }

        setRetrievedRoleUsers(data);
        setSelectedRole(role);
        setActiveRole(role); // Set the active role
        setSelectedRoleCardIndex(index)
    };

    return (
        <div className="container p-0" style={{ userSelect: 'none' }}>
            {
                loading ? (
                    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                        <div className="text-center">
                            {/* Spinner with proper rotation */}
                            <div
                                className="spinner-border text-primary"
                                role="status"
                                style={{
                                    width: "2rem",
                                    height: "2rem",
                                    borderWidth: "3px",
                                }}
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            {/* Minimalist Text */}
                            <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                        </div>
                    </div>
                )
                    :
                    (
                        <>
                            {/* Staff Data Section */}
                            <div className="row mb-4">
                                <div className="col-12">
                                    <div className="card shadow">
                                        <div className="card-body text-center">
                                            <h5>Total No. Of Staff - {noOfUsers}</h5>
                                            <div className="row mt-3">
                                                {rolesUsers.length > 0 ? (
                                                    rolesUsers.map((roleUser, idx) => (
                                                        <div className="col-md-4 col-12 mb-3" key={idx}>
                                                            <div
                                                                className={`card ${activeRole === roleUser.role ? "bg-success text-white" : "bg-light"
                                                                    } shadow-sm`}
                                                            >
                                                                <div className="card-body text-center">
                                                                    <h6>{roleUser.role}</h6>
                                                                    <h4>{roleUser.users.length}</h4>
                                                                    {roleUser.users.length > 0 ? (
                                                                        <button
                                                                            className="btn btn-sm btn-success text-decoration-none"
                                                                            onClick={() =>
                                                                                handleRoleUserView(roleUser.users, roleUser.role, idx)
                                                                            }
                                                                        >
                                                                            View List
                                                                        </button>
                                                                    ) : (
                                                                        <p>No Users Available</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {
                                                                width < 768 && (
                                                                    clickedRole && selectedRoleCardIndex === idx && (
                                                                        <div className="mt-4">
                                                                            <h6>List of {selectedRole}</h6>
                                                                            <div className="table-responsive">
                                                                                <table className="table table-hover table-striped">
                                                                                    <thead className="table-dark">
                                                                                        <tr>
                                                                                            <th>#</th>
                                                                                            <th>Name</th>
                                                                                            <th>Designation</th>
                                                                                            <th>Mobile No</th>
                                                                                            <th>Email</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {retrievedRoleUsers.length > 0 ? (
                                                                                            retrievedRoleUsers.map((user, index) => (
                                                                                                <tr key={index}>
                                                                                                    <td>{index + 1}</td>
                                                                                                    <td>{user.firstName + " " + user.lastName}</td>
                                                                                                    <td>{user.role}</td>
                                                                                                    <td>{user.countryCode + user.mobileNo}</td>
                                                                                                    <td>{user.emailId}</td>
                                                                                                </tr>
                                                                                            ))
                                                                                        ) : (
                                                                                            <tr>
                                                                                                <td colSpan="5" className="text-center">
                                                                                                    No Users Found
                                                                                                </td>
                                                                                            </tr>
                                                                                        )}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                )
                                                            }
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>No Staff Data Found</p>
                                                )}
                                            </div>
                                            {
                                                width > 768 && (
                                                    clickedRole && (
                                                        <div className="mt-4">
                                                            <h6>List of {selectedRole}</h6>
                                                            <div className="table-responsive">
                                                                <table className="table table-hover table-striped">
                                                                    <thead className="table-dark">
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>Name</th>
                                                                            <th>Designation</th>
                                                                            <th>Mobile No</th>
                                                                            <th>Email</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {retrievedRoleUsers.length > 0 ? (
                                                                            retrievedRoleUsers.map((user, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{user.firstName + " " + user.lastName}</td>
                                                                                    <td>{user.role}</td>
                                                                                    <td>{user.countryCode + user.mobileNo}</td>
                                                                                    <td>{user.emailId}</td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="5" className="text-center">
                                                                                    No Users Found
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Exams Data Section */}
                            {exams.length > 0 ? (
                                exams.map((exam, examIndex) => (
                                    <div className="row mb-4" key={exam.exam_id}>
                                        <div className="col-12">
                                            <div className="card shadow">
                                                <div className="card-body">
                                                    <h5 className="card-title text-primary">{exam.examName}</h5>
                                                    <div className="row mb-3">
                                                        {["Passed", "Processing", "Not Attended"].map((status) => {
                                                            const statusKey =
                                                                status === "Passed"
                                                                    ? "passedUsers"
                                                                    : status === "Processing"
                                                                        ? "processedUsers"
                                                                        : "nonAttendedUsers";

                                                            const count =
                                                                status === "Passed"
                                                                    ? exam.noOfPassedUsers
                                                                    : status === "Processing"
                                                                        ? exam.noOfProcessedUsers
                                                                        : exam.noOfNonAttendedUsers;

                                                            const cardClass =
                                                                activeExam === exam.exam_id && selectedType === status
                                                                    ? "bg-info text-white"
                                                                    : "border-info";

                                                            return (
                                                                <div className="col-md-4 col-12 mb-3" key={status}>
                                                                    <div className={`card bg-light ${cardClass}`} style={{ minHeight: "130px" }}>
                                                                        <div className="card-body text-center">
                                                                            <h6
                                                                                className={
                                                                                    status === "Passed"
                                                                                        ? "text-success"
                                                                                        : status === "Processing"
                                                                                            ? "text-warning"
                                                                                            : "text-danger"
                                                                                }
                                                                            >
                                                                                {status}
                                                                            </h6>
                                                                            <h4>{count}</h4>
                                                                            {count > 0 && (
                                                                                <button
                                                                                    className="btn btn-success btn-sm text-white"
                                                                                    onClick={() =>
                                                                                        handleViewClick(
                                                                                            exam,
                                                                                            statusKey,
                                                                                            exam.exam_id, examIndex
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    View List
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {/* Conditionally render the list only for the clicked exam */}
                                                                    {width < 768 && (
                                                                        clickedExamId === exam.exam_id && passedClick && selectedExamIndex === examIndex && (selectedTypeIndex === statusKey) && (
                                                                            <div className="mt-4">
                                                                                <h6 className="text-secondary">
                                                                                    {selectedExam} - {selectedType}
                                                                                </h6>
                                                                                <div className="table-responsive">
                                                                                    <table className="table table-hover table-striped">
                                                                                        <thead className="table-dark">
                                                                                            <tr>
                                                                                                <th>#</th>
                                                                                                <th>Name</th>
                                                                                                <th>Designation</th>
                                                                                                <th>Mobile No</th>
                                                                                                <th>Email</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {retrievedUsers.length > 0 ? (
                                                                                                retrievedUsers.map((user, index) => (
                                                                                                    <tr key={index}>
                                                                                                        <td>{index + 1}</td>
                                                                                                        <td>{user.firstName + " " + user.lastName}</td>
                                                                                                        <td>{user.role}</td>
                                                                                                        <td>{user.countryCode + user.mobileNo}</td>
                                                                                                        <td>{user.emailId}</td>
                                                                                                    </tr>
                                                                                                ))
                                                                                            ) : (
                                                                                                <tr>
                                                                                                    <td colSpan="5" className="text-center">
                                                                                                        No Users Found
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    {/* Conditionally render for desktop view as well */}
                                                    {width > 768 && clickedExamId === exam.exam_id && passedClick && (
                                                        <div className="mt-4">
                                                            <h6 className="text-secondary">
                                                                {selectedExam} - {selectedType}
                                                            </h6>
                                                            <div className="table-responsive">
                                                                <table className="table table-hover table-striped">
                                                                    <thead className="table-dark">
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>Name</th>
                                                                            <th>Designation</th>
                                                                            <th>Mobile No</th>
                                                                            <th>Email</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {retrievedUsers.length > 0 ? (
                                                                            retrievedUsers.map((user, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{user.firstName + " " + user.lastName}</td>
                                                                                    <td>{user.role}</td>
                                                                                    <td>{user.countryCode + user.mobileNo}</td>
                                                                                    <td>{user.emailId}</td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="5" className="text-center">
                                                                                    No Users Found
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center">
                                    <h5 className="text-muted">Loading Data...</h5>
                                </div>
                            )}

                        </>
                    )
            }


        </div>
    );
};

export default Dashboard;
